import { defineConfig } from "cva";
import { twMerge } from "./twmerge.config";

export const { cva, cx, compose } = defineConfig({
	hooks: {
		onComplete: (className) => twMerge(className),
	},
});
